export const MIN_ARROW_LEFT = 16;

export const MAX_ARROW_LEFT = 283;
